module.exports = __webpack_public_path__ + "img/organization-security.8d76555.svg";